import { ReactElement, memo } from 'react';
import { ListItemButton } from '@mui/material';

import AccessFeature from '../AccessFeature';

import { DialogExportRouteRoadmapListItemButtonProps } from './types';

const DialogExportRouteRoadmapListItemButton = ({
  validSubscriptionFeature,
  ...restProps
}: DialogExportRouteRoadmapListItemButtonProps): ReactElement => {
  if (validSubscriptionFeature) {
    return (
      <AccessFeature.ListItemButton
        {...validSubscriptionFeature}
        {...restProps}
      />
    );
  }

  return <ListItemButton {...restProps} />;
};

export default memo(DialogExportRouteRoadmapListItemButton);
